// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"DropdownMenu_linkButton__ZyR0l","link":"DropdownMenu_link__J5xy3"};